export default __webpack_public_path__ + "static/media/ketosis_shortcut@3x.904b64e2.jpg";